import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Search, ExternalLink, Star } from 'lucide-react';
import { toast } from 'sonner';
import { PageHeader } from '../PageHeader';
import { appLinks } from '../data';
const categories = ['All', ...Array.from(new Set(appLinks.map(a => a.category).filter(Boolean) as string[]))];
export function AppsPage() {
  const [query, setQuery] = useState('');
  const [cat, setCat] = useState('All');
  const [favs, setFavs] = useState<Record<string, boolean>>({
    Velocify: true
  });
  const filtered = appLinks.filter(a => {
    const matchesQuery = a.label.toLowerCase().includes(query.toLowerCase());
    const matchesCat = cat === 'All' || a.category === cat;
    return matchesQuery && matchesCat;
  });
  return <>
      <PageHeader title="Apps" subtitle="Single sign-on access to every tool you use." data-id="element-387" />

      <div className="flex flex-col sm:flex-row gap-3 mb-6" data-id="element-388">
        <div className="relative flex-1 max-w-md" data-id="element-389">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-navy-400" data-id="element-390" />
          <input value={query} onChange={e => setQuery(e.target.value)} placeholder="Search apps…" className="w-full pl-11 pr-4 py-2.5 rounded-full bg-white border border-navy-100 focus:border-gold-400 focus:outline-none focus:ring-2 focus:ring-gold-400/30 text-sm text-navy-900" data-id="element-391" />
        </div>
        <div className="flex flex-wrap gap-2" data-id="element-392">
          {categories.map(c => <button key={c} onClick={() => setCat(c)} className={`px-3.5 py-1.5 rounded-full text-sm font-semibold transition-colors ${cat === c ? 'bg-navy-600 text-white' : 'bg-white text-navy-600 border border-navy-100 hover:border-gold-400'}`} data-id="element-393">
              {c}
            </button>)}
        </div>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4" data-id="element-394">
        {filtered.map((app, i) => <motion.div key={app.label} initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: i * 0.03
      }} className="relative bg-white rounded-xl border border-navy-100 hover:shadow-md hover:border-gold-400 transition-all group" data-id="element-395">
            <button onClick={() => setFavs(f => ({
          ...f,
          [app.label]: !f[app.label]
        }))} className="absolute top-3 right-3 z-10 text-navy-300 hover:text-gold-500" aria-label={`Favorite ${app.label}`} data-id="element-396">
              <Star className={`w-4 h-4 ${favs[app.label] ? 'fill-gold-500 text-gold-500' : ''}`} data-id="element-397" />
            </button>
            {app.url ? <a href={app.url} target="_blank" rel="noopener noreferrer" className="block p-5 focus:outline-none focus:ring-2 focus:ring-gold-400/40 rounded-xl" aria-label={`Launch ${app.label}`} data-id="element-398">
                <span className={`w-14 h-14 rounded-xl ${app.color} text-white font-bold flex items-center justify-center mb-3 group-hover:scale-105 transition-transform`} data-id="element-399">
                  {app.initials}
                </span>
                <p className="font-bold text-navy-900" data-id="element-400">{app.label}</p>
                <p className="text-xs text-navy-400 mb-3" data-id="element-401">{app.description}</p>
                <span className="inline-flex items-center gap-1 text-xs font-bold text-gold-600" data-id="element-402">
                  Launch <ExternalLink className="w-3 h-3" data-id="element-403" />
                </span>
              </a> : <button type="button" onClick={() => toast(`${app.label} opens once single sign-on is connected.`)} className="block w-full text-left p-5 focus:outline-none focus:ring-2 focus:ring-gold-400/40 rounded-xl" data-id="element-404">
                <span className={`w-14 h-14 rounded-xl ${app.color} text-white font-bold flex items-center justify-center mb-3 group-hover:scale-105 transition-transform`} data-id="element-405">
                  {app.initials}
                </span>
                <p className="font-bold text-navy-900" data-id="element-406">{app.label}</p>
                <p className="text-xs text-navy-400 mb-3" data-id="element-407">{app.description}</p>
                <span className="inline-flex items-center gap-1 text-xs font-bold text-gold-600" data-id="element-408">
                  Launch <ExternalLink className="w-3 h-3" data-id="element-409" />
                </span>
              </button>}
          </motion.div>)}
      </div>
    </>;
}